@if (displayIf) {
  <mat-list-item
    class="pegase-menu-entry-with-child"
    [attr.data-tfa]="'mat-list-item-route_' + navTitle"
    [class.aChildPathMatchesActualRoute]="aChildPathMatchesActualRoute"
    [class.children-container-closed]="!isOpened"
    (click)="clickHandler()"
    [class.disabled]="disabled"
    [disableRipple]="disabled"
    >
    <span [matTooltip]="navTooltip? navTooltip:navTitle" matTooltipPosition="right" class="pegase-menu-entry_tooltip-wrapper">
      @if (svgIcon) {
        <mat-icon [svgIcon]="svgIcon" data-tfa="icon-svg-icon"></mat-icon>
      }
      @if (matIcon) {
        <mat-icon [attr.data-tfa]="'mat-list-item-icon_' + matIcon">{{matIcon}}</mat-icon>
      }
      <span style="grid-column: 2;">{{ navTitle }}</span>
      <mat-icon class="toggle-icon" data-tfa="icon-expand-less">expand_less</mat-icon>
    </span>
  </mat-list-item>
}

@if (!disabled) {
  <mat-nav-list class="children-container" [class.open]="isOpened">
    <ng-content></ng-content>
  </mat-nav-list>
}

